import { FunctionComponent } from 'react'
import styles from './TrusteeHome.module.scss'
import Title from '@/components/_custom/Title/title'
import { useTranslation } from 'react-i18next'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { useAuth } from '@/modules/context/AuthContext'
import LogoutIcon from '@mui/icons-material/ExitToApp'
import CachedIcon from '@mui/icons-material/Cached'
import { removeServiceWorker } from '@/modules/utils/serviceWorker'
import { Assignment, Groups, ListAlt, LockReset, Restaurant } from '@mui/icons-material'
import FamiliesIcon from '@mui/icons-material/SupervisedUserCircle'
import GroupIcon from '@mui/icons-material/HolidayVillage'
import TranslateIcon from '@mui/icons-material/Translate'
import ArticleIcon from '@mui/icons-material/Article'
import HelpIcon from '@mui/icons-material/Help'
import HomeCase from '../HomeCase/homeCase'

interface CALDHomeMobileProps {
    backendVersion: string
    frontendVersion: string
    setDialogChangeLanguageOpen: (open: boolean) => void
    setDialogForgottenPasswordOpen: (open: boolean) => void
    setDialogSupportOpen: (open: boolean) => void
}

const TrusteeHomeMobile: FunctionComponent<CALDHomeMobileProps> = ({
    backendVersion,
    frontendVersion,
    setDialogChangeLanguageOpen,
    setDialogForgottenPasswordOpen,
    setDialogSupportOpen
}: CALDHomeMobileProps) => {
    const { t } = useTranslation()

    const { logout } = useAuth()

    const navigate: NavigateFunction = useNavigate()

    return (
        <div className={styles.PagePosition}>
            <div className={styles.HomePlacement}>
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('families')}
                        icon={<FamiliesIcon className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/adults')}
                    />
                    <HomeCase
                        text={t('staff')}
                        icon={<Groups className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/staff')}
                    />
                </div>
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('tasksAndNotes')}
                        icon={<ListAlt className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/taskNote')}
                    />
                    <HomeCase
                        text={t('suggestions')}
                        icon={<Assignment className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/suggest')}
                    />
                </div>
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('meal')}
                        icon={<Restaurant className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/meal')}
                    />
                    <HomeCase
                        text={t('group')}
                        icon={<GroupIcon className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/group')}
                    />
                </div>
            </div>
            <div className={styles.HomePlacement}>
                <Title text={t('settings')} className={styles.Title} />
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('language')}
                        icon={<TranslateIcon className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => setDialogChangeLanguageOpen(true)}
                    />
                    <HomeCase
                        text={t('password')}
                        icon={<LockReset className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => setDialogForgottenPasswordOpen(true)}
                    />
                </div>
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('refresh')}
                        icon={<CachedIcon className={styles.CaseIcon} />}
                        onClick={removeServiceWorker}
                    />
                    <HomeCase text={t('logout')} icon={<LogoutIcon className={styles.CaseIcon} />} onClick={logout} />
                </div>
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('ourArticles')}
                        icon={<ArticleIcon className={styles.CaseIcon} />}
                        href={'https://www.cald.fr/nos-articles/'}
                    />
                    <HomeCase
                        text={t('help')}
                        icon={<HelpIcon className={styles.CaseIcon} />}
                        href={'https://www.cald.fr/aide-structure'}
                    />
                </div>
            </div>
            <div className={styles.Version}>
                <a onClick={() => setDialogSupportOpen(true)}>
                    V{backendVersion}/{frontendVersion}
                </a>
            </div>
        </div>
    )
}

export default TrusteeHomeMobile
